module.exports = "img/socla.1789ab.png";